import { PageType } from '../../types/domain.types';
import { api } from '../api-client.config';
import { useMutation } from '@tanstack/react-query';

const createPage = (page: PageType) => api.post(`/pages`, { ...page });

export const useCreatePageMutation = () => {
  return useMutation({
    mutationKey: ['createPage'],
    mutationFn: createPage,
  });
};
